import { Injectable } from '@angular/core';
import { LBSErrorHandler, LBSErrorHandlerResult } from '../error-handler';
import { LoggingService } from '../../logging/logic/logging.service';
import { ImsError } from 'src/app/_util/ims-error';

@Injectable({
  providedIn: 'root',
})
export class RestErrorHandler implements LBSErrorHandler {
  // Lifecycle
  constructor(private logger: LoggingService) {}

  public async handleError(error: Error): Promise<LBSErrorHandlerResult> {
    console.log('JBHandleError RestErrorHandler error', error);
    if (error?.['status'] != undefined && error?.['error'] != undefined) {
      const errorData = error['error'];

      let subtitle = 'ERROR-HANDLERS.GENERIC-ERRORS.SUBTITLE';
      if (errorData.messageCode) {
        subtitle = errorData.messageCode;
      }

      let message = 'ERROR-HANDLERS.GENERIC-ERRORS.MESSAGE';
      let messageTranslate = true;
      if (errorData.message) {
        message = errorData.message;
        messageTranslate = false;
      }

      return {
        alert: {
          title: 'ERROR-HANDLERS.GENERIC-ERRORS.TITLE',
          subtitle: subtitle,
          message: message,
          messageTranslate: messageTranslate,
          confirm: 'ERROR-HANDLERS.GENERIC-ERRORS.CONFIRM',
          confirmFunc: () => {},
          showExportLog: false,
        },
      };
    }

    if (error instanceof ImsError) {
      console.log('JBHandleError RestErrorHandler error type2');
      const imsError = error as ImsError;
      return imsError.getErrorHandlerResult();
    }

    return undefined;
  }
}
